import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';
import { IInitResponsePacket, ReturnCode, MessageType } from 'app/modules/remote-control-ng/definitions';

enum InitPayloadFlags {
    SCREEN_INFO = 1,
    MODEL_INFO = 2
}

/** PC_INIT MessageType */
export class InitMessage extends BaseMessage {
    public response: IInitResponsePacket = <IInitResponsePacket>{};

    protected deserializeHeader = (buffer: MemoryBuffer): void => {
        this.header.size = buffer.readInt32BE();
        this.header.sig = buffer.readUInt8();
        this.header.command = buffer.readUInt8();
        this.header.flags = buffer.readCompInt();
    }

    public deserializeBody(memoryBuffer: MemoryBuffer): void {
        const returnCode = memoryBuffer.readUInt8();
        const verHigh = memoryBuffer.readUInt8();
        const verLow = memoryBuffer.readUInt8();
        const result: IInitResponsePacket = <IInitResponsePacket>{};
        result.returnCode = returnCode;
        result.versionHigh = verHigh;
        result.versionLow = verLow;

        const payloadFlags = memoryBuffer.readUInt32BE();
        // eslint-disable-next-line no-bitwise
        result.hasScreenInfo = ((payloadFlags & InitPayloadFlags.SCREEN_INFO) !== 0);
        // eslint-disable-next-line no-bitwise
        result.hasModelInfo = ((payloadFlags & InitPayloadFlags.MODEL_INFO) !== 0);

        if (returnCode === ReturnCode.PCR_OK) {
            if (result.hasScreenInfo) {
                const width = memoryBuffer.readInt32BE();
                const height = memoryBuffer.readInt32BE();
                const rotation = memoryBuffer.readInt32BE();
                result.width = width;
                result.height = height;
                result.rotation = rotation;
            }

            if (result.hasModelInfo) {
                const deviceModel = memoryBuffer.readString();
                result.model = deviceModel;
            }
            result.osType = memoryBuffer.readInt32BE();
        }

        result.permissions = memoryBuffer.readInt64BE();
        this.response = result;
    }
}

/** PC_STOP MessageType */
export class StopMessage extends BaseMessage {
    constructor() {
        super();
        this.header.command = MessageType.PC_STOP;
    }
}

/** PC_RESET MessageType */
export class SoftResetMessage extends BaseMessage {
    constructor() {
        super();
        this.header.command = MessageType.PC_RESET;
    }
}

/** PC_HARDRESET MessageType 
 * This HardReset Message is just created for future uses. The feature is not determined to be implemented for now */
export class HardResetMessage extends BaseMessage {
    constructor() {
        super();
        this.header.command = MessageType.PC_HARDRESET;
    }
}

/** PC_RCPAUSE MessageType */
export class RcPauseMessage extends BaseMessage {
    // no custom data to serialize 
}

/** PC_TH_ACK MessageType */
export class ThAckMessage extends BaseMessage {
    constructor() {
        super();
        this.header.command = MessageType.PC_TH_ACK;
    }
    // nothing to serialize or deserialize
}
